import { Box, Typography } from "@mui/material"
import React from "react"
import { HomePageButton } from "./HomePageButton"
import { pagesUrl } from "../../../core/appConstants"

export function ReferralCard(): React.JSX.Element {
  return (
    <Box
      borderRadius={3}
      sx={{
        minHeight: "250px",
        background: "#E6F0FB",
        boxShadow: "2px 4px 20px 0px rgba(0, 0, 0, 0.05)",
        p: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 2,
      }}>
      <Typography variant="h6">Parrainage</Typography>
      <Typography variant="body1">Recommandez notre solution à une entreprise et recevez 20% de rétrocommission</Typography>

      <HomePageButton label="Devenir parrain" path={pagesUrl.REFERRAL} />
    </Box>
  )
}
